<template>
  <div class="main" style="height:calc(100% - 20px);padding:10px">
    <div class="table" style="height:calc(100% - 30px);overflow: auto;">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="未阅" name="first">
          <div style="display: flex;justify-content: end; ">
            <el-button type="primary" plain size="mini" @click="read"
            >全部标为已阅</el-button
            >
          </div>
          <el-table
            border
            stripe
            size="small"
            :header-cell-style="{ background: '#ECF5FF', color: '#606266' }"
            :data="tableData"
            :highlight-current-row="true"
            height="calc(100vh - 160px)"
            style="width:100%; margin-top: 10px;"
          >
            <el-table-column
              property="noticeTypeName"
              label="消息提示名称"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              property="content"
              label="内容"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <el-button style="color:#4873C0;" type="text" @click="clickInfo(scope.row)">{{
                  scope.row.content
                }}</el-button>
              </template>
            </el-table-column>
            <el-table-column
              property="sendTime"
              width="150"
              label="发送时间"
            ></el-table-column>
            <el-table-column
              property="status"
              align="center"
              width="120"
              label="状态"
            >
              <template slot-scope="scope">
                <span style="padding: 5px 8px;color: white;border-radius: 4px;" :style="{background:scope.row.status =='1'?'orange':'yellowgreen'}">{{ scope.row.status == "1" ? "未阅" : "已阅" }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="已阅" name="second">
          <el-table
            border
            stripe
            size="small"
            :header-cell-style="{ background: '#ECF5FF', color: '#606266' }"
            :data="tableData"
            :highlight-current-row="true"
            height="calc(100vh - 120px)"
            style="width:100%"
          >
            <el-table-column
              property="noticeTypeName"
              label="消息提示名称"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              property="content"
              label="内容"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <el-button style="color:#4873C0;" type="text" @click="clickInfo(scope.row)">{{
                  scope.row.content
                }}</el-button>
              </template>
            </el-table-column>
            <el-table-column
              property="sendTime"
              width="150"
              label="发送时间"
            ></el-table-column>
            <el-table-column
              property="status"
              align="center"
              width="120"
              label="状态"
            >
              <template slot-scope="scope">
                <span style="padding: 5px 8px;color: white;border-radius: 4px;" :style="{background:scope.row.status =='1'?'orange':'yellowgreen'}">{{ scope.row.status == "1" ? "未阅" : "已阅" }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="全部" name="third">
          <el-table
            border
            stripe
            size="small"
            :header-cell-style="{ background: '#ECF5FF', color: '#606266' }"
            :data="tableData"
            :highlight-current-row="true"
            height="calc(100vh - 120px)"
            style="width:100%"
          >
            <el-table-column
              property="noticeTypeName"
              label="消息提示名称"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              property="content"
              label="内容"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <el-button style="color:#4873C0;" type="text" @click="clickInfo(scope.row)">{{
                  scope.row.content
                }}</el-button>
              </template>
            </el-table-column>
            <el-table-column
              property="sendTime"
              width="150"
              label="发送时间"
            ></el-table-column>
            <el-table-column
              property="status"
              align="center"
              width="120"
              label="状态"
            >
              <template slot-scope="scope">
                <span style="padding: 5px 8px;color: white;border-radius: 4px;" :style="{background:scope.row.status =='1'?'orange':'yellowgreen'}">{{ scope.row.status == "1" ? "未阅" : "已阅" }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="footer" style="background:#ECF5FF">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 30, 50,100]"
        :page-size="rows"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { fixed_parent_id } from "@/utils";
export default {
  data() {
    return {
      activeName: "first",
      tableData: [],
      currentPage: 1,
      rows: 15,
      total: 0,
      typeName: "",
      status: 1,
      // 父级菜单id
      resourceId: this.$route.query.resourceId
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    read() {
      if (this.tableData.length > 0) {
        this.tableData.forEach(item => {
          this.$axios
            .put("/api/noticeMsg/updateNoticeMsg?id=" + item.id)
            .then(res => {
              console.log(res, 10);
            })
            .catch(error => {
              this.$message.warning(error);
            });
        });
        this.getTableData();
      }
    },
    getTableData() {
      this.$axios
        .get(
          "/api/noticeMsg/getTodoMsgList?page=" +
            this.currentPage +
            "&rows=" +
            this.rows +
            "&status=" +
            this.status +
            "&resourceId=" +(!!this.$route.query.resourceId?this.$route.query.resourceId:fixed_parent_id)


        )
        .then(res => {
          if (res.data.success) {
            this.tableData = res.data.data.rows;
            this.total = res.data.data.total;
          }
        });
    },
    handleClick() {
      if (this.activeName == "first") {
        this.currentPage = 1;
        this.rows = 15;
        this.status = 1;
        this.getTableData();
      }
      if (this.activeName == "second") {
        this.currentPage = 1;
        this.rows = 15;
        this.status = 2;
        this.getTableData();
      }
      if (this.activeName == "third") {
        this.currentPage = 1;
        this.rows = 15;
        this.status = 3;
        this.getTableData();
      }
    },
    handleSizeChange(val) {
      this.rows = val;
      this.currentPage = 1;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.rows = val;
      this.currentPage = 1;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData();
    },
    clickInfo(data) {
      // console.log('11111111111',data.targetUrl);
      //选中左边菜单
      // window.parent.postMessage({target: 'clickInfo',url: data.targetUrl},"*")
      // this.$parent.$EventBus.$emit("getUrl",data.targetUrl);
      // window.location.href = data.targetUrl;
      this.$axios
        .put("/api/noticeMsg/updateNoticeMsg?id=" + data.id)
        .then(res => {
          this.getTableData();
        })
        .catch(error => {
          this.$message.warning(error);
        });

      if (data.target && data.target == "_self") {
        window.location.replace(data.targetUrl || data.targetUrl1);
      } else {
        window.open(data.targetUrl);
      }
    }
  }
};
</script>

<style lang="less" scoped>
///deep/ .el-table__body tr.current-row > td {
//  background: #019bff !important;
//  color: white !important;
//}
///deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
//  background: #019bff !important;
//}
///deep/ .el-tabs__item.is-active {
//  color: white;
//}
/deep/.el-tabs__item.is-active{
  color:#4873C0;
}

/deep/.el-tabs__active-bar{
  background-color: #4873C0;
  height: 3px;
}
/deep/.el-button--primary{
  background-color:#4873C0 !important;
  border-color:#4873C0 !important;
  color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/views/TooltipInfo.vue